<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t("view") }} {{ $t("seattype") }}</div>
      <div>
        <a
          v-if="$can('update', 'Seat Type')"
          class="btn-blue"
          @click.prevent.stop="goToRoute"
          >{{ $t("edit") }}</a
        >
        <router-link class="btn-blue" to="seat-type"
          >{{ $t("seattype") }} {{ $tc("list", 2) }}</router-link
        >
      </div>
    </div>

    <div class="all-details-container">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("selected") }} {{ $tc("cinema", 2) }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ seatTypes.cine_name }}
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("selected") }} {{ $t("screens") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ seatTypes.screen_name }}
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t("seattype") }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ seatTypes.sst_seat_type }}
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("noof") }} {{ $tc("seat", 1) }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ seatTypes.sst_no_of_seats }}
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">Seat Color Code</div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <input
                  type="color"
                  v-model="seatTypes.sst_seat_color_code"
                  disabled
                />
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $tc("status", 1) }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ seatTypes.sst_is_active === "Y" ? $t("active") : "" }}
              </div>
            </div>
          </div>

          <div
            v-if="login_user_role_id === 1"
            class="col-md-12 py-2 border-bottom"
          >
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("createdby") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <!-- <span>{{ $tc('ho', 1) }} {{ $t('manager') }}</span> -->
                <span>{{ seatTypes.created_by }}</span>
              </div>
            </div>
          </div>

          <div
            v-if="login_user_role_id === 1"
            class="col-md-12 py-2 border-bottom"
          >
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("createdat") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <span class="mr-3">{{ seatTypes.created_at | dateparse }}</span>
                <!-- <span>12:05 AM</span> -->
              </div>
            </div>
          </div>

          <div
            v-if="login_user_role_id === 1"
            class="col-md-12 py-2 border-bottom"
          >
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("modifiedby") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <!-- <span>{{ $tc('ho', 1) }} {{ $t('manager') }}</span> -->
                <span>{{ seatTypes.updated_by }}</span>
              </div>
            </div>
          </div>

          <div v-if="login_user_role_id === 1" class="col-md-12 py-2">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("modifiedat") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <span class="mr-3">{{ seatTypes.updated_at | dateparse }}</span>
                <!-- <span>12:05 AM</span> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CinemasService from "@/services/CinemasService";
import ScreenService from "@/services/ScreenService";
import SeatService from "@/services/SeatService";
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      login_user_role_id: null,
      // Saif
      Cinemas: [],
      Screens: [],
      selectedCinema: "",
      selectedScreen: "",
      seatTypes: {
        cine_name: "",
        screen_name: "",
        cinema_id: null,
        screen_id: null,
        sst_id: null,
        sst_seat_type: "",
        sst_seat_color_code: "#FF0000",
        sst_no_of_seats: 0,
        sst_is_active: "Y",
        updated_at: null,
        updated_by: null,
        created_at: null,
        created_by: null,
      },
      // Saif
    };
  },
  computed: {},
  beforeMount() {
    const { id } = this.$route.query;
    if (id) {
      this.getSeatTypesDetails(id);
    } else {
      this.$router.go(-1);
    }

    const { role_id } = this.secureStore.get("USINFO");
    this.login_user_role_id = role_id;
  },
  mounted() {},
  methods: {
    // Saif
    getSeatTypesDetails: function (sst_id) {
      SeatService.GetSeatTypesById({ sst_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            let obj = data.Records[0];
            // this.seatTypes = {
            //   ...this.seatTypes,
            //   ...data.Records[0]
            // };
            Object.keys(this.seatTypes).map((x) => {
              this.seatTypes[x] = obj[x] || this.seatTypes[x];
              if (x === "created_by") {
                this.getViewUsersDetails(obj[x], "created_by", "seatTypes");
              } else if (x === "updated_by") {
                this.getViewUsersDetails(obj[x], "updated_by", "seatTypes");
              }
            });
            this.selectedCinema = data.Records[0].cine_name;
            this.selectedScreen = data.Records[0].screen_name;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    getViewUsersDetails(user_id, fieldvalue, key) {
      this[key][fieldvalue] = "-";
      if (user_id) {
        MasterService.GetUserInfoById({ user_id })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this[key][fieldvalue] = data.Records[0].user_name;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      }
    },
    goToRoute: function () {
      this.$router.push({
        path: "/cinema-manager/edit-seat-type",
        query: {
          id: this.seatTypes.sst_id,
        },
      });
    },
    // Saif
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/SeatTypeComponents/viewSeatType.vue